import * as React from 'react'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import CardMedia from '@mui/material/CardMedia'
import Typography from '@mui/material/Typography'
import {CardActionArea} from '@mui/material'
import DeckLogic from '../logic/DeckLogic'
import TagsDisplay from './TagsDisplay'
import {Link, useNavigate} from 'react-router-dom'
import {Deck} from '../model/models'
import Button from '@mui/material/Button'
import CardActions from '@mui/material/CardActions'
import PublicIcon from '@mui/icons-material/Public';
import Box from '@mui/material/Box'
import LockIcon from '@mui/icons-material/Lock';

interface DeckCardProps {
  deck: Deck
  isPublic: boolean
  onAddPublic?: (deckId: number) => void
}

export default function DeckCard(props: DeckCardProps) {
  const navigate = useNavigate()
  const deck = props.deck

  if (props.isPublic) {
    return (
      <Card>
        <div onClick={_ => navigate(`/deck/public/${deck.id}`)}>
          <CardActionArea>
            {deck.imageMeta && <CardMedia
              sx={{
                borderRadius: 3,
                px: 2,
                pt: 2
              }}
              component="img"
              alt={deck.imageMeta.alt}
              image={DeckLogic.getImageUrl(deck)}
            />}
            <CardContent>
              <Typography sx={{mx: .7}} variant="body1">
                {deck.title}
              </Typography>
              <Typography sx={{mb: 2, mx: .7}} variant="body2" color="text.secondary">
                {deck.description}
              </Typography>

              <TagsDisplay tags={deck.tags}/>
            </CardContent>
          </CardActionArea>
        </div>
        <CardActions>
          <Button
            onClick={_ => {
              props.onAddPublic && props.onAddPublic(deck.id)
            }}
            sx={{textTransform: 'none', color: 'white'}}
            variant="outlined"
            size="small"
            color="primary">Add to My Decks</Button>
        </CardActions>
      </Card>
    )
  }

  return (
    <Card>
      <CardActionArea onClick={_ => navigate(`/deck/${deck.id}`)}>
        <CardMedia
          sx={{
            borderRadius: 3,
            px: 2,
            pt: 2
          }}
          component="img"
          alt={deck.imageMeta?.alt}
          src={DeckLogic.getImageUrl(deck)}
        />
        <CardContent>
          <Typography sx={{mx: .7}} variant="body1">
            {deck.title}
          </Typography>
          <Typography sx={{mb: 1, mx: .7}} variant="body2" color="text.secondary">
            {deck.description}
          </Typography>
          <TagsDisplay tags={deck.tags}/>
          {deck.isPublic && <Box display='flex' sx={{mt: 1, alignItems: 'center'}}>
            <PublicIcon sx={{mr: .4}}/> <Typography variant="body2">Public</Typography>
            {/*<LockIcon sx={{mr: .2}}/> <Typography variant="body2">Private</Typography>*/}
          </Box>}
        </CardContent>
      </CardActionArea>
    </Card>
  )
}
